import type { FunctionComponent } from "react";
import { JsonLd } from "react-schemaorg";
import type { AnalysisNewsArticle, CreativeWork } from "schema-dts";

import { useArticleSchemaContext } from "~/components/article/article-schema/contexts";
import type { SwGCompatibleSchema } from "~/components/article/article-schema/types";

type Props = Record<string, never>;

export const AnalysisNewsArticleSchema: FunctionComponent<Props> = () => {
  const { schemaData } = useArticleSchemaContext();

  return schemaData ? (
    <JsonLd<SwGCompatibleSchema<CreativeWork, AnalysisNewsArticle>>
      item={{
        "@context": "https://schema.org",
        "@type": ["CreativeWork", "AnalysisNewsArticle"],
        ...schemaData,
      }}
    />
  ) : null;
};

AnalysisNewsArticleSchema.displayName = "AnalysisNewsArticleSchema";
